import { render, staticRenderFns } from "./menu_sous-menu.vue?vue&type=template&id=f9bb00a8"
import script from "./menu_sous-menu.js?vue&type=script&lang=js&external"
export * from "./menu_sous-menu.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports